import { useEffect, useState } from "react";
import TableList from "../../components/TableList/TableList";
import Pagination from "../../components/reusable/Pagination/Pagination";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { toastError } from "../../utils/toast";
import "./Transacciones.css";
import Button from "../../components/reusable/Button/Button";
import { useAppDispatch } from "../../app/store";
import { setLoadingPageScreen } from "../../features/Dashboard/Slices/dashboardSlice";
import xlsx from "json-as-xlsx";
import { DateInput } from "../../components/DateInput";
import { TimeInput } from "../../components/TimerInput";
import ModalConfirmation from "../../components/reusable/ModalConfirmation/ModalConfirmation";
import dateFormat from "dateformat";
import Input from "../../components/reusable/Input/Input";
import Selector from "../../components/reusable/Selector/Selector";
import DateTimePicker from "../../components/reusable/DateTimePicker/DateTimePicker";
import useAuth from "../../hooks/useAuth";
import moment from "moment";
export enum EstadoTX {
  DESCONOCIDO = "DESCONOCIDO",
  INICIADA = "INICIADA",
  "RECHAZADA CLOUD SYNC" = "RECHAZADA_CLOUD_SYNC",
  "RECHAZADA CLOUD ASYNC" = "RECHAZADA_CLOUD_ASYNC",
  "RECHAZADA ORACLE" = "RECHAZADA_ORACLE",
  "APROBADA CLOUD" = "APROBADA_CLOUD",
  "APROBADA ORACLE" = "APROBADA_ORACLE",
  "ERROR" = "ERROR",
}

const getRangoMesActual = () => {
  const hoy = moment();
  return {
    fechaInicio: hoy.clone().startOf("month").format("YYYY-MM-DDTHH:mm"),
    fechaFin: hoy.clone().endOf("month").format("YYYY-MM-DDTHH:mm"),
  };
};

const formatFechaInicioBody = (fechaISO: string) => {
  if (!fechaISO) return "";
  return `${fechaISO.replace("T", " ")}:00.000`;
};

const formatFechaFinBody = (fechaISO: string) => {
  if (!fechaISO) return "";
  return `${fechaISO.replace("T", " ")}:59.999`;
};

function Transacciones() {
  const rangoMesActual = getRangoMesActual();
  const [fecha, setFecha] = useState(dateFormat(new Date(), "yyyymmdd"));
  const [hora, setHora] = useState("");
  const [fechaInicio, setFechaInicio] = useState(rangoMesActual.fechaInicio);
  const [fechaFin, setFechaFin] = useState(rangoMesActual.fechaFin);
  const [currentPage, setCurrentPage] = useState(1);
  const [estado, setEstado] = useState("");
  const [idTx, setIdTx] = useState("");
  const [tipoTx, setTipoTx] = useState("");
  const [idAlumnoPrograma, setIdAlumnoPrograma] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [idCupo, setIdCupo] = useState("");
  const [totalEvents, setTotalEventos] = useState(0);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [eventos, setEventos] = useState<any[]>([]);
  const [desinscripcionesTransito, setDesinscripcionesTransito] = useState(0);
  const [reservasEnTransito, setReservasEnTransito] = useState(0);
  const [txIniciadas, setTxIniciadas] = useState(0);
  const [txAprobadasCloud, setTxAprobadasCloud] = useState(0);
  const [txRechazasCloud, setTxRechazasCloud] = useState(0);
  const [txRechazasOracle, setTxRechazasOracle] = useState(0);
  const [txAprobadasOracle, setTxAprobadasOracle] = useState(0);

  const [txDesIniciadas, setDesTxIniciadas] = useState(0);
  const [txDesAprobadasCloud, setDesTxAprobadasCloud] = useState(0);
  const [txDesRechazasCloud, setDesTxRechazasCloud] = useState(0);
  const [txDesRechazasOracle, setDesTxRechazasOracle] = useState(0);
  const [txDesAprobadasOracle, setDesTxAprobadasOracle] = useState(0);

  const [txCSIniciadas, setCSTxIniciadas] = useState(0);
  const [txCSAprobadasCloud, setCSTxAprobadasCloud] = useState(0);
  const [txCSRechazasCloud, setCSTxRechazasCloud] = useState(0);
  const [txCSRechazasOracle, setCSTxRechazasOracle] = useState(0);
  const [txCSAprobadasOracle, setCSTxAprobadasOracle] = useState(0);

  const { hasPermission } = useAuth();
  useEffect(() => {
    console.log("estado:", estado);
    console.log("CHECK:", estado.length > 0 ? estado : null);
  }, [estado]);

  const estadosOptions = [
    { text: "DESCONOCIDO", value: "DESCONOCIDO" },
    { text: "INICIADA", value: "INICIADA" },
    { text: "RECHAZADA_CLOUD_SYNC", value: "RECHAZADA_CLOUD_SYNC" },
    { text: "RECHAZADA_CLOUD_ASYNC", value: "RECHAZADA_CLOUD_ASYNC" },
    { text: "RECHAZADA_ORACLE", value: "RECHAZADA_ORACLE" },
    { text: "APROBADA_CLOUD", value: "APROBADA_CLOUD" },
    { text: "APROBADA_ORACLE", value: "APROBADA_ORACLE" },
    { text: "ERROR", value: "ERROR" },
  ];

  const tipoTxOptions = [
    { text: "CAMBIO SECCION", value: "CAMBIO_SECCION" },
    { text: "INSCRIPCION", value: "INSCRIPCION" },
    { text: "DESINSCRIPCION", value: "DESINSCRIPCION" },
  ];

  const pageSize = 25;
  const dispatch = useAppDispatch();

  const setLoading = (newState: boolean) => {
    dispatch(setLoadingPageScreen(newState));
  };

  const exportTransacciones = async () => {
    try {
      const fechaNum = parseInt(fecha);
      const horaNum = hora ? parseInt(hora) : null;
      const data = await dashboardAPI.exportTransacciones(fechaNum, horaNum);
      let settings = {
        fileName: "Transacciones", // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };

      xlsx(data, settings);
    } catch (error) {
      console.log("ERROR: " + JSON.stringify(error));
      toastError();
    }
  };

  const delTransacciones = async () => {
    await dashboardAPI.delTransacciones();
    setLoading(true);
    try {
      getTransacciones();
    } catch (error) {
      toastError();
    }
    setShowDeleteConfirmation(false);
    setLoading(false);
  };

  const limpiarFiltros = () => {
    setFecha(dateFormat(new Date(), "yyyymmdd"));
    setHora("");
    setEstado("");
    setIdTx("");
    setTipoTx("");
    setIdAlumnoPrograma("");
    setIdCurso("");
    setIdCupo("");
    setCurrentPage(1);
    // Actualizar la lista después de limpiar
    // getTransacciones();
  };

  const limpiarFiltrosEstadisticas = () => {
    const rango = getRangoMesActual();
    setFechaInicio(rango.fechaInicio);
    setFechaFin(rango.fechaFin);
  };

  const getTransacciones = async (newPage?: number) => {
    setLoading(true);
    try {
      const page = newPage ? (newPage - 1) * pageSize : 0;

      const newData = await dashboardAPI.getTransaccionesPaginated(
        pageSize,
        page,
        Number.parseInt(fecha),
        Number.parseInt(hora),
        estado.length > 0 ? estado : null,
        idTx.length > 0 ? Number(idTx) : null,
        tipoTx.length > 0 ? tipoTx : null,
        idAlumnoPrograma.length > 0 ? Number(idAlumnoPrograma) : null,
        idCurso.length > 0 ? Number(idCurso) : null,
        idCupo.length > 0 ? Number(idCupo) : null,
      );
      if (newPage) {
        setCurrentPage(newPage);
      } else {
        setCurrentPage(1);
      }

      setEventos(newData.transacciones);
      setTotalEventos(newData.totalCount);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  const getEstadosGlobales = async () => {
    setLoading(true);
    try {
      const estados = await dashboardAPI.getEstadoGlobalTransacciones(
        formatFechaInicioBody(fechaInicio),
        formatFechaFinBody(fechaFin),
      );

      setDesinscripcionesTransito(estados.DesinscripcionesTransito);
      setReservasEnTransito(estados.ReservasEnTransito);
      setTxIniciadas(estados.Inscripciones.TxIniciadas);
      setTxAprobadasCloud(estados.Inscripciones.TxAprobadasCloud);
      setTxRechazasCloud(estados.Inscripciones.TxRechazasCloud);
      setTxRechazasOracle(estados.Inscripciones.TxRechazasOracle);
      setTxAprobadasOracle(estados.Inscripciones.TxAprobadasOracle);

      setDesTxIniciadas(estados.Desinscripciones.TxIniciadas);
      setDesTxAprobadasCloud(estados.Desinscripciones.TxAprobadasCloud);
      setDesTxRechazasCloud(estados.Desinscripciones.TxRechazasCloud);
      setDesTxRechazasOracle(estados.Desinscripciones.TxRechazasOracle);
      setDesTxAprobadasOracle(estados.Desinscripciones.TxAprobadasOracle);

      setCSTxIniciadas(estados.CambioSeccion.TxIniciadas);
      setCSTxAprobadasCloud(estados.CambioSeccion.TxAprobadasCloud);
      setCSTxRechazasCloud(estados.CambioSeccion.TxRechazasCloud);
      setCSTxRechazasOracle(estados.CambioSeccion.TxRechazasOracle);
      setCSTxAprobadasOracle(estados.CambioSeccion.TxAprobadasOracle);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  useEffect(() => {
    getTransacciones();
    getEstadosGlobales();
  }, []);

  return (
    <div className="flex flex-1 transaccionesPage">
      <ModalConfirmation
        topBorderWarn
        show={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={() => delTransacciones()}
        title="¿Desea eliminar todos las transacciones registradas?"
      />
      <div className="transaccionesPage">
        {/* Estadísticas de Transacciones */}
        <div className="px-10 py-2">
          <div
            className="bg-white rounded-lg shadow-sm p-3"
            style={{ border: "1.5px solid #d1d5db" }}
          >
            <div className="flex flex-nowrap items-end gap-3 mb-2 pb-2 border-b border-gray-200">
              <h3 className="text-sm font-semibold text-textPrimary whitespace-nowrap pb-2">
                Estadísticas
              </h3>
              <div className="flex gap-2">
                <DateTimePicker
                  label="Fecha desde"
                  value={fechaInicio}
                  onChange={setFechaInicio}
                  className="w-44 statsDateTimePicker"
                />
                <DateTimePicker
                  label="Fecha hasta"
                  value={fechaFin}
                  onChange={setFechaFin}
                  className="w-44 statsDateTimePicker"
                  defaultTime="23:59"
                />
              </div>
              <div className="flex gap-2 ml-auto">
                <Button
                  label="Limpiar"
                  onClick={limpiarFiltrosEstadisticas}
                  theme="default"
                  iconName="eraser"
                />
                <Button
                  label="Aplicar"
                  iconName="search"
                  onClick={() => getEstadosGlobales()}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
              {/* Reservas y Desinscripciones en Tránsito */}
              <div
                className="bg-white rounded-lg shadow-sm p-2.5"
                style={{ border: "1.5px solid #d1d5db" }}
              >
                <h3 className="text-sm font-semibold text-gray-700 mb-1.5">
                  En Tránsito
                </h3>
                <div className="space-y-0">
                  <div
                    className="flex justify-between items-center gap-2 pb-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Reservas:
                    </span>
                    <span className="text-xs font-medium text-blue-600 text-right">
                      {reservasEnTransito}
                    </span>
                  </div>
                  <div className="flex justify-between items-center gap-2 pt-1">
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Desinscripciones:
                    </span>
                    <span className="text-xs font-medium text-orange-600 text-right">
                      {desinscripcionesTransito}
                    </span>
                  </div>
                </div>
              </div>

              {/* Inscripciones */}
              <div
                className="bg-white rounded-lg shadow-sm p-2.5"
                style={{ border: "1.5px solid #d1d5db" }}
              >
                <h3 className="text-sm font-semibold text-green-700 mb-1.5">
                  INSCRIPCIONES
                </h3>
                <div className="space-y-0">
                  <div
                    className="flex justify-between items-center gap-2 pb-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Iniciadas:
                    </span>
                    <span className="text-xs font-medium text-right">
                      {txIniciadas}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txAprobadasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right break-words">
                      {txRechazasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right">
                      {txRechazasOracle}
                    </span>
                  </div>
                  <div className="flex justify-between items-center gap-2 pt-1">
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txAprobadasOracle}
                    </span>
                  </div>
                </div>
              </div>

              {/* Desinscripciones */}
              <div
                className="bg-white rounded-lg shadow-sm p-2.5"
                style={{ border: "1.5px solid #d1d5db" }}
              >
                <h3 className="text-sm font-semibold text-red-700 mb-1.5">
                  DESINSCRIPCIONES
                </h3>
                <div className="space-y-0">
                  <div
                    className="flex justify-between items-center gap-2 pb-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Iniciadas:
                    </span>
                    <span className="text-xs font-medium text-right">
                      {txDesIniciadas}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txDesAprobadasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right break-words">
                      {txDesRechazasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.20)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right">
                      {txDesRechazasOracle}
                    </span>
                  </div>
                  <div className="flex justify-between items-center gap-2 pt-1">
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txDesAprobadasOracle}
                    </span>
                  </div>
                </div>
              </div>

              {/* Cambios de Sección */}
              <div
                className="bg-white rounded-lg shadow-sm p-2.5"
                style={{ border: "1.5px solid #d1d5db" }}
              >
                <h3 className="text-sm font-semibold text-purple-700 mb-1.5">
                  CAMBIOS DE SECCIÓN
                </h3>
                <div className="space-y-0">
                  <div
                    className="flex justify-between items-center gap-2 pb-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Iniciadas:
                    </span>
                    <span className="text-xs font-medium text-right">
                      {txCSIniciadas}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txCSAprobadasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Cloud:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right break-words">
                      {txCSRechazasCloud}
                    </span>
                  </div>
                  <div
                    className="flex justify-between items-center gap-2 py-1 border-b"
                    style={{ borderColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Rechazadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-red-600 text-right">
                      {txCSRechazasOracle}
                    </span>
                  </div>
                  <div className="flex justify-between items-center gap-2 pt-1">
                    <span className="text-xs text-gray-600 flex-shrink-0">
                      Aprobadas Oracle:
                    </span>
                    <span className="text-xs font-medium text-green-600 text-right">
                      {txCSAprobadasOracle}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* SECCION FILTROS */}
        <div className="pt-3 flex flex-col">
          {/* <strong className="pl-10 text-lg mb-3">Transacciones</strong> */}
          <div className="px-10 mb-3 flex gap-4">
            <div
              className="flex-1 bg-white rounded-lg shadow-sm p-3"
              style={{ border: "1.5px solid #d1d5db" }}
            >
              <h3 className="text-sm font-semibold text-textPrimary mb-1">
                Filtros de transacciones
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                <div className="flex flex-col">
                  <DateInput value={fecha} onChange={setFecha} label="Fecha" />
                </div>
                <div className="flex flex-col">
                  <TimeInput value={hora} onChange={setHora} label="Hora" />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">Estado</strong>
                  <Selector
                    options={estadosOptions}
                    onSelect={setEstado}
                    placeholder="Estado"
                    value={estado}
                  />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">Tipo de TX</strong>
                  <Selector
                    options={tipoTxOptions}
                    onSelect={setTipoTx}
                    placeholder="Tipo de TX"
                    unselectedText="Sin filtrar"
                    value={tipoTx}
                  />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">idTx</strong>
                  <Input
                    value={idTx}
                    onChange={setIdTx}
                    placeholder="idTx"
                    type="number"
                  />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">idAlumnoPrograma</strong>
                  <Input
                    value={idAlumnoPrograma}
                    onChange={setIdAlumnoPrograma}
                    placeholder="idAlumnoPrograma"
                    type="number"
                  />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">idCurso</strong>
                  <Input
                    value={idCurso}
                    onChange={setIdCurso}
                    placeholder="idCurso"
                    type="number"
                  />
                </div>
                <div className="flex flex-col">
                  <strong className="text-sm mb-1">idCupo</strong>
                  <Input
                    value={idCupo}
                    onChange={setIdCupo}
                    placeholder="idCupo"
                    type="number"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-3">
                <Button
                  label="Limpiar filtros"
                  onClick={limpiarFiltros}
                  theme="default"
                  iconName="eraser"
                />
                <Button
                  label="Buscar"
                  iconName="search"
                  onClick={() => getTransacciones()}
                  disabled={!hasPermission("transacciones", "actualizar_lista")}
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div
                className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-2"
                style={{ border: "1.5px solid #d1d5db" }}
              >
                <h3 className="text-sm font-semibold text-textPrimary mb-1.5">
                  Acciones globales
                </h3>
                <Button
                  label="Borrar todo"
                  onClick={() => setShowDeleteConfirmation(true)}
                  theme="red"
                  disabled={!hasPermission("transacciones", "borrar_todo")}
                />
                <Button
                  label="Exportar a XLS"
                  onClick={() => exportTransacciones()}
                  theme="green"
                  disabled={!hasPermission("transacciones", "exportar_a_xls")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col px-10 py-2">
          {eventos.length < 1 && <h2>No se encontraron transacciones</h2>}
          <div className="tableListCont">
            <TableList list={eventos} page="transacciones" />
          </div>
          <Pagination
            onPageChange={getTransacciones}
            currentPage={currentPage}
            totalCount={totalEvents}
            pageSize={pageSize}
          />
        </div>
      </div>
    </div>
  );
}

export default Transacciones;
